import React, { useReducer } from 'react';
import { reducer } from 'reducers/error';

const initialState = { showError: false };

const ErrorContext = React.createContext(initialState);

const ErrorProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <ErrorContext.Provider value={{ state, dispatch }}>{props.children}</ErrorContext.Provider>;
};

const ErrorConsumer = ErrorContext.Consumer;

export { ErrorProvider, ErrorContext, ErrorConsumer };
